import { STATUS_TYPE } from '../../../enum';

export interface Attachments {
    documentType: string;
    fileName: string;
    fileType: string;
    id: string;
    key: string;
}

export interface CreateAgent {
    name: string;
    email: string;
    mobileNumber: string;
    whatsappNumber?: string;
    password: string;
    countryCallingCode: string;
    countryCode: string;
    language: string;
    photoId?: string;
    brokerLicenseId?: string;
    idAttachmentId?: string;
    activeState: boolean;
}

export interface UpdateAgent {
    id: string;
    name?: string;
    email?: string;
    mobileNumber?: string;
    whatsappNumber?: string;
    countryCallingCode?: string;
    countryCode?: string;
    language?: string;
    photoId?: string;
    brokerLicenseId?: string;
    idAttachmentId?: string;
    activeState?: boolean;
}

export interface FindAgentList {
    search?: string;
    status?: 'active' | 'inactive';
    creationDateFrom?: string;
    creationDateTo?: string;
    limit?: number;
    skip?: number;
}

export interface Agent {
    id: string;
    name: string;
    email: string;
    mobileNumber: string;
    whatsappNumber?: string;
    companyId: string;
    countryCallingCode: string;
    countryCode: string;
    language: string;
    activeState: boolean;
    userProfileImage?: Attachments;
    attachments: Attachments[];
    createdAt: string;
    updatedAt: string;
}

export interface InitialState {
    data: Agent[];
    skip: number;
    limit: number;
    totalRecords: number;
    currentPage: number;
    status: STATUS_TYPE;
    isError: boolean;
    isLoading: boolean;
    isSuccess: boolean;
    errorMessage: string;
}

export const initialState: InitialState = {
    data: [],
    skip: 0,
    limit: 10,
    totalRecords: 0,
    currentPage: 0,
    status: 'idle',
    isError: false,
    isLoading: false,
    isSuccess: false,
    errorMessage: '',
};

